/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { PlusIcon } from '@heroicons/react/solid';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { toHeaderCase } from 'js-convert-case';
import { TweetyWidget } from '@/widgets/tweety-widget-react-main/TweetyWidget';

export interface IKanbanCreateModalProps {
    cardType?: string;
    modalTitle?: string;
    type?: 'card' | 'list';
    show?: boolean;
    onHide?(): void;
    titleDefaultValue?: string;
    titlePlaceholder?: string;
    attributeTypeValue?: {
        label: string;
        value: string;
    }[];
    attributeForm?: ITweetyWidgetProps;
    attributeTypePlaceholder?: string;
    attributeTypeDefaultValue?: string;
    requiredValue?: boolean;
    requiredLabel?: string;
    onSubmit?({ title, description, isRequired }: any): void;
    closeButtonLabel?: string;
    onDynamicFieldChange?(id: string, payload: any): void;
}

const SwalWithBootstrapButtons = withReactContent(
    Swal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary me-3',
            cancelButton: 'btn btn-gray',
        },
        buttonsStyling: false,
    })
);

export const KanbanCreateModal = (props: IKanbanCreateModalProps) => {
    const { modalTitle, type, show, cardType, attributeForm, fontScale, isOrgNameExist } =
        props;
    console.log('hi->', cardType);
    const [title, setTitle] = useState('');
    const [attributeType, setAttributeType] = useState('');
    const [showOptions, setShowOptions] = useState(false);
    const [isRequired, setRequired] = useState(false);
    const [options, setOptions] = useState<any>('');

    const onTitleChange = (e: any) => setTitle(e.target.value);
    const onRequiredChange = (e: any) => setRequired(e.target.checked);
    const onOptionsChange = (e: any) => {
        setOptions(e.target.value);
    };
    const onAttributeTypeChange = (e: any) => {
        setAttributeType(e.target.value);
        if (e?.target?.value === 'radio') {
            setShowOptions(true);
        }
    };
    const onHide = () => props.onHide && props.onHide();

    async function isOrgNameExistCall(payload: any) {
        try {
            if (!isOrgNameExist) {
                throw new Error('isOrgNameExist function is not provided');
            }
            const bool_res = await isOrgNameExist(payload);
            console.log('isOrgNameExist raw response:', bool_res);
            return bool_res;
        } catch (error) {
            console.error('Error in isOrgNameExist:', error);
            throw error;
        }
    }    

    const _renderOptionsIf = () => {
        if (showOptions) {
            return (
                <Form.Group id="show-options" className="mb-3">
                    <S.FormControl
                        fontScale={fontScale}
                        required
                        autoFocus
                        type="text"
                        value={options}
                        onChange={onOptionsChange}
                        placeholder={
                            'Enter options as comma separated value for user to pick'
                        }
                    />
                </Form.Group>
            );
        }
    };
    return (
        <Modal as={Modal.Dialog} centered show={show} onHide={onHide} size="lg">
            {/* <Form className="modal-content p-3"> */}
            <Modal.Header className="pb-0 border-0">
                <h5 as={Modal.Title} className="fw-normal">
                    {cardType
                        ? `Add a new ${toHeaderCase(cardType)}`
                        : modalTitle}
                </h5>
                <Button variant="close" onClick={onHide} />
            </Modal.Header>
            <Modal.Body className="pb-0">
                {/* <Form.Group id="title" className="mb-3">
                        <S.FormControl fontScale={fontScale}
                            required
                            autoFocus
                            type="text"
                            value={title}
                            defaultValue={props.titleDefaultValue}
                            onChange={onTitleChange}
                            placeholder={
                                cardType
                                    ? `${toHeaderCase(cardType)} Name`
                                    : props.titlePlaceholder
                            }
                        />
                    </Form.Group> */}
                <TweetyWidget
                    {...attributeForm}
                    labelColor={'#104382'}
                    fontScale={fontScale}
                    onChange={(id, payload) => {
                        console.log("Asirpayload ",attributeForm,id, payload, 'pu->');
                        props?.onDynamicFieldChange &&
                            props?.onDynamicFieldChange(id, payload);
                    }}
                    renderSubmitButton={() => (
                        <Modal.Footer className="justify-content-start border-0 pt-0">
                            <Button
                                variant="outline-gray-500"
                                onClick={async (payload) => {
                                    console.log('Asironclick pu->', payload, cardType);

                                    if (cardType === 'Director') {
                                        const textMessage = `Do you really want to cancel?`;

                                        const result =
                                            await SwalWithBootstrapButtons.fire(
                                                {
                                                    icon: 'error',
                                                    title: 'Confirmation',
                                                    text: textMessage,
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Yes',
                                                    cancelButtonText: 'Cancel',
                                                }
                                            );

                                        if (result.isConfirmed) {
                                            onHide();
                                        }
                                    } else {
                                        onHide();
                                    }
                                }}
                            >
                                {props.closeButtonLabel}
                            </Button>
                            <Button
                                variant="secondary"
                                className="d-inline-flex align-items-center"
                                type="submit"
                                //  onClick={onSubmit}
                            >
                                <PlusIcon className="icon icon-xs me-2" />
                                {cardType
                                    ? `Save ${toHeaderCase(cardType)}`
                                    : modalTitle}
                            </Button>
                        </Modal.Footer>
                    )}
                    onFormSubmit={async (payload) => {
                        console.log('Asirpayload pu->', payload, cardType);
                        if(isOrgNameExist && (cardType === 'Subsidiary' || cardType === 'Branch')){
                            let res_data = await isOrgNameExistCall(payload);
                            console.log('Asir pu->', payload," isOrgNameExist", res_data.isOrgNameExist);
                            if (res_data.isOrgNameExist) {
                                SwalWithBootstrapButtons.fire({
                                    icon: 'error',
                                    title: `${cardType} Name Already Exist`,
                                    text: `Please enter a different ${cardType} Name`,
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                });
                                return;
                            }
                        }
                        if (cardType === 'Director') {
                            const textMessage = `Are you sure you want to save this information?`;

                            const result = await SwalWithBootstrapButtons.fire({
                                icon: 'success',
                                title: 'Confirmation',
                                text: textMessage,
                                showCancelButton: true,
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'Cancel',
                            });

                            if (result.isConfirmed) {
                                props?.onSubmit && props?.onSubmit(payload);
                            }
                        } else {
                            props?.onSubmit && props?.onSubmit(payload);
                        }
                    }}
                />
            </Modal.Body>

            {/* </Form> */}
        </Modal>
    );
};

KanbanCreateModal.defaultProps = {
    modalTitle: 'Add a new Attribute',
    type: 'card',
    show: false,
    requiredLabel: 'Required',
    closeButtonLabel: 'Cancel',
    titlePlaceholder: 'Attribute Name',
    attributeTypePlaceholder: 'Attribute Type',
    attributeTypeValue: [],
    trueValueLabel: 'Enter true value label',
    falseValueLabel: 'Enter false value label',
};
